export function ugcPhotoUploadSrc(store) {
    const state = store.getState();
    const curalateUrl = state.core.constants.thirdParty.default.curalate.photo_upload_endpoint;
    const url = `${curalateUrl}?locale=${state.core.language}&source=${window.location.href}`;

    return url;
}
